import React from "react";

const Import = () => {
    return (
        <div className="content">
            <div className="col-12">
                <div id="page-header">
                    <h1>Імпорт товарів</h1>
                </div>
                <div className=" float-start">
                    <div className="input-group mb-3">
                        <input type="file" className="form-control" id="customFile" value="" />
                    </div>
                </div>
                <div className="clearfix"></div>
                <p className="clearfix">(максимальний розмір файлу — 128 МБ)</p>
                <p className="">
                    <button className="add btn btn-primary" type="submit" name="">
                        Імпортувати
                    </button>
                </p>
                <div className="block block_help">
                    <div className="card border-warning mb-3">
                        <div className="card-body">
                            <p>Збережіть таблицю в форматі CSV </p>
                        </div>
                    </div>
                    <div className="card border-info mb-3">
                        <div className="card-body">
                            <p>В першому рядку повинні бути назви колонок в форматі:</p>
                            <table className="table table-striped" id="moves">
                                <tbody>
                                    <tr className="crow">
                                        <td className="middle_name">Товар</td>
                                        <td>назва товару</td>
                                    </tr>
                                    <tr className="crow">
                                        <td className="middle_name">Категорія</td>
                                        <td>категорія товару</td>
                                    </tr>

                                    <tr className="crow">
                                        <td className="middle_name">Ціна</td>
                                        <td>ціна товару</td>
                                    </tr>

                                    <tr className="crow">
                                        <td className="middle_name">Ціна знижка</td>
                                        <td>ціна зі знижкою</td>
                                    </tr>

                                    <tr className="crow">
                                        <td className="middle_name">Ціна закупка</td>
                                        <td>ціна закупки</td>
                                    </tr>

                                    <tr className="crow">
                                        <td className="middle_name">Склад</td>
                                        <td>кількість товару на складі</td>
                                    </tr>
                                    <tr className="crow">
                                        <td className="middle_name">IMEI</td>
                                        <td>imei/sn товару</td>
                                    </tr>
                                    <tr className="crow">
                                        <td className="middle_name">Статус</td>
                                        <td>статус товару (новий, рефабріш і тд)</td>
                                    </tr>
                                </tbody>
                            </table>
                            <p></p>
                        </div>
                    </div>
                    <p>
                        <a href="files/import/example.csv" id="start" className="add btn btn-primary">
                            Завантажити приклад файлу
                        </a>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Import;
